import React, { useState } from 'react'
import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import { Slider } from '@mui/material'
import Stepper from '../../../components/atoms/Stepper/Stepper'

function Guests({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	const MIN = 3
	const MAX = 2000
	const handleChange = (e) => {
		const value = e.target.value
		if (value >= MIN && value <= MAX) {
			setWeddingData({ ...weddingData, guestCount: value })
		}
	}
	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>How many guests will you host?</h2>
					<p>Enter your count below</p>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.priceRange}>
								<input
									value={weddingData.guestCount}
									onChange={handleChange}
									style={{
										width: 'fit-content',
										margin: '0 auto',
										textAlign: 'center',
										fontFamily: 'var(--body-font-one)',
										fontWeight: '400',
									}}
								/>
							</div>
						</div>
						<div style={{ padding: '0 30px' }}>
							<Slider
								value={weddingData.guestCount}
								onChange={(e, newValue) =>
									setWeddingData({
										...weddingData,
										guestCount: newValue,
									})
								}
								max={MAX}
								min={MIN}
								sx={{
									color: '#7ca6bd',
									width: '100%',
									marginBottom: '40px',
									marginTop: '22px',
									'& .MuiSlider-track': {
										backgroundColor: '#7ca6bd',
									},
									'& .MuiSlider-thumb': {
										border: '0.1px solid white',
										width: '12px',
										height: '12px',
									},
									'& .MuiSlider-rail': {
										backgroundColor: '#FFFFFF',
										opacity: 1,
									},
								}}
							/>
						</div>
					</div>
				</div>
				<ButtonCustom size="lg" data-cy="wizard-next" onClick={() => handleNext()}>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={1.5} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default Guests
